import { motion, MotionValue, useTransform } from "framer-motion";
import { memo } from "react";

const BrushCursor = memo(function BrushCursor({
  cursorPositionMotionValue,
  cursorTimeMotionValue,
  cursorDurationMotionValue,
  currentTimeMotionValue,
  width,
  cursorWidth = 2,
  realtimeCursorWidth = 2,
}: {
  cursorPositionMotionValue: MotionValue<number>;
  cursorTimeMotionValue: MotionValue<number>;
  cursorDurationMotionValue: MotionValue<number>;
  currentTimeMotionValue: MotionValue<number>;
  width: number;
  cursorWidth?: number;
  realtimeCursorWidth?: number;
}) {
  const cursorPositionPercentageMotionValue = useTransform(
    cursorPositionMotionValue,
    (position) => {
      return `calc(${Math.floor(position * 100)}% - ${cursorWidth / 2}px)`;
    },
  );

  // Calculate position of current time relative to the cursor-centered time range
  const realtimeCursorPosition = useTransform(() => {
    const cursorPosition = cursorPositionMotionValue.get();
    const cursorTime = cursorTimeMotionValue.get();
    const currentTime = currentTimeMotionValue.get();
    let currentTimePosition =
      (currentTime - cursorTime) / cursorDurationMotionValue.get();

    currentTimePosition = Math.max(
      cursorPosition - 1,
      Math.min(cursorPosition, currentTimePosition),
    );
    // currentTimePosition = currentTimePosition - cursorPositionMotionValue.get();
    currentTimePosition = currentTimePosition * width;

    return (
      Math.floor(currentTimePosition) +
      cursorWidth / 2 -
      realtimeCursorWidth / 2
    );
  });

  return (
    <>
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          left: cursorPositionPercentageMotionValue,
          width: `${cursorWidth}px`,
          height: "100%",
          backgroundColor: "var(--primary)",
          zIndex: 7,
          boxShadow: "0 0 4px var(--primary)",
          borderRadius: "calc(var(--radius) - 4px)",
          pointerEvents: "none", // Let clicks pass through to parent
        }}
        whileHover={{ scaleX: 1.5 }}
        whileTap={{ scaleX: 1.5 }}
      >
        <motion.div
          style={{
            position: "absolute",
            top: 2,
            left: realtimeCursorPosition,
            width: `${realtimeCursorWidth}px`,
            height: "calc(100% - 4px)",
            backgroundColor: "red",
            zIndex: 8,
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingBottom: "4px",
            borderRadius: "calc(var(--radius) - 4px)",
          }}
          transition={{ duration: 1 }}
        />
      </motion.div>
    </>
  );
});

export { BrushCursor };
